import * as XLSX from "xlsx";

// Downloads rows (plain objects, keys become headers) as `${fileName}.xlsx`
export const downloadExcel = (rows, fileName, sheetName = "Sheet1") => {
  const book = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(book, XLSX.utils.json_to_sheet(rows), sheetName);
  XLSX.writeFile(book, `${fileName}.xlsx`);
};

// Today's date for export file names, e.g. "2026-10-06"
export const today = () => new Date().toISOString().split("T")[0];

// Downloads sheets given as rows of cells ([{ name, rows: [[...], ...] }]) as `${fileName}.xlsx`
export const downloadSheets = (sheets, fileName) => {
  const book = XLSX.utils.book_new();
  sheets.forEach(({ name, rows }) => XLSX.utils.book_append_sheet(book, XLSX.utils.aoa_to_sheet(rows), name));
  XLSX.writeFile(book, `${fileName}.xlsx`);
};
